import ttAboutImg from "../../assets/ttAboutUs.jpg";

export default function Hero() {
  return (
    <div className="relative w-full overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 py-8 sm:py-8 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0 lg:grid lg:max-w-none lg:grid-cols-2 lg:gap-x-16 lg:gap-y-8 xl:grid-cols-1 xl:grid-rows-1 xl:gap-x-8">
          <h1 className="max-w-2xl text-balance text-5xl font-semibold tracking-tight text-ttNavy-600 sm:text-7xl lg:col-span-2 xl:col-auto">
            We've been there before. We know how to make it better.
          </h1>
          <div className="mt-6 max-w-xl lg:mt-0 xl:col-end-1 xl:row-start-1">
            <p className="text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
              We are team moms, club coaches, and veterans of the tournament
              scene. We have seven kids between the two of us, who are all at
              various stages of the crazy world of club lacrosse! We’ve been in
              your shoes and know how stressful it can be to coordinate
              everything when your team is traveling. Sitting on the beach one
              day, under our rented umbrella and chairs, we wondered why there
              was no service like this for kids’ sports. Wouldn’t having all of
              your tournament essentials taken care of by someone else make it
              more fun for parents? From there, we hit the ground running with
              our concierge concept, and six months later Tourney Tents MD was
              born!
            </p>
          </div>
          <img
            alt=""
            src={ttAboutImg}
            className="mt-6 aspect-[6/5] w-full max-w-lg rounded-2xl object-cover sm:mt-16 lg:mt-0 lg:max-w-none xl:row-span-2 xl:row-end-2 xl:mt-6"
          />
        </div>
      </div>
    </div>
  );
}
